import axios from "axios";
import { authHeader } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const SC_ACTIVATION_KEY = "m2hat_sc_activation";

export const createActivation = (payload) => axios.post(`${API}/activations`, payload, { headers: authHeader() }).then((r) => r.data);
export const listActivations = () => axios.get(`${API}/activations`, { headers: authHeader() }).then((r) => r.data);
export const revokeActivation = (id) => axios.post(`${API}/activations/${id}/revoke`, {}, { headers: authHeader() }).then((r) => r.data);
export const restoreActivation = (id) => axios.post(`${API}/activations/${id}/restore`, {}, { headers: authHeader() }).then((r) => r.data);
export const patchActivation = (id, payload) => axios.patch(`${API}/activations/${id}`, payload, { headers: authHeader() }).then((r) => r.data);
export const deleteActivation = (id) => axios.delete(`${API}/activations/${id}`, { headers: authHeader() }).then((r) => r.data);
export const activateCode = (code) => axios.post(`${API}/activations/${encodeURIComponent(code)}/activate`).then((r) => r.data);
export const checkCode = (code) => axios.get(`${API}/activations/${encodeURIComponent(code)}/check`).then((r) => r.data);

export const activationUrl = (code) => `${window.location.origin}/p/super-cerveau/a/${code}`;
export const loadActivation = () => { try { return JSON.parse(localStorage.getItem(SC_ACTIVATION_KEY) || "null"); } catch { return null; } };
export const saveActivation = (a) => localStorage.setItem(SC_ACTIVATION_KEY, JSON.stringify(a));
export const clearActivation = () => localStorage.removeItem(SC_ACTIVATION_KEY);

export const ACTIVATION_ERRORS = {
  unknown: "Ce lien d'activation n'existe pas. Vérifiez l'adresse ou demandez un nouveau lien à votre praticien.",
  revoked: "Ce lien d'activation a été désactivé par votre praticien.",
  expired: "Ce lien n'a pas été utilisé dans les 30 jours : il a expiré. Demandez un nouveau lien à votre praticien.",
};
